import { axiosGet } from "../../../Helpers";

export const loadJobSeekerStats = async (id, setLoading) => {
  setLoading(true);
  const response = await axiosGet(`user/jobSeekerStatistics/${id}`);
  setLoading(false);
  const data = response.data?.data;
  console.log("stats data", data);
  return data;
};
